import { AccountInfo } from "winslow-core";
import { getRequest } from "./client";
import config from "environment";

const { baseApi } = config;

export const apiGetAccountInfo = async (
  userId: string
): Promise<AccountInfo | null> => {
  const fetchURL = `${baseApi}/accounts/info/${userId}`;
  return await getRequest(fetchURL, "API/apiGetAccountInfo");
};

export const apiIncrementQuestionsAsked = async (
  userId: string
): Promise<AccountInfo | null> => {
  const fetchURL = `${baseApi}/accounts/increment/${userId}`;
  return await getRequest(fetchURL, "API/apiIncrementQuestionsAsked");
};
